import type { PreviewIntegration } from '@/modules/Workspaces/KnowledgeHub/Integrations/integrationTypes'
import NetdocumentsLogo from './NetdocumentsLogo.vue'

export const netdocumentsIntegration: PreviewIntegration = {
  id: 'netdocuments',
  name: 'NetDocuments',
  description:
    "Integrate your documents and emails from NetDocuments to enhance your AI's understanding of your content.",
  icon: NetdocumentsLogo,
}
